import { render, staticRenderFns } from "./PageFundraisingGoals.vue?vue&type=template&id=3da472c8&"
import script from "./PageFundraisingGoals.vue?vue&type=script&lang=ts&"
export * from "./PageFundraisingGoals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports